export const GET_STOCK_MONNAIE = "GET_STOCK_MONNAIE";
export const GET_STOCK_MONNAIE_REQUEST = "GET_STOCK_MONNAIE_REQUEST";
export const GET_STOCK_MONNAIE_FAILURE = "GET_STOCK_MONNAIE_FAILURE";
export const GET_RETRAITS_HISTORY = "GET_RETRAITS_HISTORY";
export const GET_RETRAITS_HISTORY_FAILURE = "GET_RETRAITS_HISTORY_FAILURE";
export const GET_RETRAITS_HISTORY_REQUEST = "GET_RETRAITS_HISTORY_REQUEST";
